import Logger from '@editor/services/Logger/Logger'
import { Vector3Like } from 'three'

export type Polyline = Vector3Like[]

export interface Cluster {
  points: Vector3Like[]
  centroid?: Vector3Like
}

/**
 * Pipeline execution statistics
 */
export interface PipelineStats {
  totalTime: number
  inputPoints: number
  outputPolylines: number
  stages: {
    preprocessing: { module: string; time: number; pointsIn: number; pointsOut: number }[]
    extraction: { module: string; time: number; pointsIn: number; polylinesOut: number }
    postprocessing: { module: string; time: number; polylinesIn: number; polylinesOut: number }[]
  }
}

/**
 * Base class for all modules (preprocessing, extraction, postprocessing)
 */
export class Module {
  protected logger?: Logger

  setLogger(logger: Logger): void {
    this.logger = logger
  }
}

/**
 * Base class for module configs
 */
export interface ModuleConfig {
  verbose?: boolean
}
